<template>
  <div id="app">
    <div class="container">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>

<style lang="scss">
  html,
  body {
    font-family: Renault Regular,Helvetica,Arial,sans-serif!important;
  }
  h1, h2 {
    font-family: Renault,Renault Regular,Helvetica,Arial,sans-serif!important;
    font-weight: 400;
    text-transform: none;
    word-wrap: break-word;
  }
  .container {
    overflow: hidden;
    max-width: 800px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue